/* eslint-disable import/prefer-default-export */
import transformer from '@/services/echeanceFacturation/echeanceFacturationServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/EcheanceFacturation/';

export async function getAll(search) {
  const inputServer = transformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function getBudgetTotalHt(search) {
  const inputServer = transformer(search);
  const response = await HTTP.post(URL_BASE + 'PGetBudgetTotalHtAsync', inputServer);
  return response;
}
